import { Room, ERoomIcon } from "../../AppDataType";

import RoomCarousel from "../RoomCarousel/RoomCarousel";
import RoomIcon from "../RoomIcon/RoomIcon";
import { useEffect, useState } from "react";

interface Props {
    roomInfo: Room;
    bookTo: string;
    bookText: string;
    onAllImagesLoaded: () => void; // callback que pasa el componente padre.
    isHidden: boolean; // isLoading en el componente padre.
}

const RoomFullCard: React.FC<Props> = ({ roomInfo, bookTo, bookText, onAllImagesLoaded, isHidden }) => {
    const [imagesLoaded, setImagesLoaded] = useState(0);

    useEffect(() => {
        if (imagesLoaded === roomInfo.images.roomImages.length && isHidden) {
            onAllImagesLoaded();
            setImagesLoaded(0);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [imagesLoaded]);

    const handleImageLoad = () => {
        setImagesLoaded(prev => prev + 1);
    }

    return (
        <section aria-label="room-info"
                 className={`container mx-auto bg-first-solid rounded-xl p-4 mb-8
                           ${ isHidden ? "hidden" : "flex flex-col gap-8"}`}>
            <div className="relative">
                <div className="lg:w-[90%] lg:mx-auto text-fifth-solid 
                                flex flex-col gap-4 justify-center lg:p-4
                                lg:backdrop-brightness-[.5] lg:rounded-xl">
                    <h4 className="text-2xl font-bold lg:text-3xl text-center py-2">
                        { roomInfo.name }
                    </h4>

                    <div className="flex justify-center">
                        <ul role="list" 
                            aria-label="room-icons"
                            className="grid grid-cols-3 lg:grid-cols-4 gap-y-6 gap-x-8">
                        {
                            roomInfo.icons.map((roomIcon, index) => (
                                <li role="listitem" 
                                    key={index}
                                    className="flex flex-col lg:flex-row items-center gap-2">
                                    <RoomIcon icon={roomIcon.icon as ERoomIcon}
                                              className="lg:size-7"/>
                                    <span className="text-sm lg:text-base text-center">
                                        {roomIcon.text}
                                    </span>
                                </li>
                            ))
                        }
                        </ul>
                    </div>
                    <div aria-label="room-description"
                         className="flex flex-col gap-4">
                    {
                        roomInfo.description.map((paragraph, index) => (
                            <p key={index}
                               className="text-base/8 text-justify lg:text-left">
                                {paragraph}
                            </p>
                        ))
                    }
                    </div>
                    <a href={ bookTo }
                       target="_blank"
                       rel="noopener noreferrer"
                       className="block w-full bg-second-solid text-center py-3 px-6
                                  rounded-xl transition-colors duration-300 ease-in-out
                                hover:bg-third-solid hover:text-first-solid">
                        { bookText }
                    </a>
                </div>
            </div>
            <div>
                <RoomCarousel mainSlides={roomInfo.images.roomImages}
                              thumbsSlides={roomInfo.images.thumbnailsImages}
                              onImageLoad={handleImageLoad}/>
            </div>
        </section>
    )
}

export default RoomFullCard;
